module.exports = __webpack_public_path__ + "img/Portrait-taped-Susie.aa46565d.svg";